(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-bookshop"] && !Shopify.designMode) return;
  try {
    
  // Mobile menu drawer functionality
  const menuToggle = document.querySelector('.header__menu-toggle');
  const mobileDrawer = document.getElementById('mobile-menu-drawer');
  const closeBtn = document.querySelector('.mobile-menu-drawer__close');
  const backdrop = document.querySelector('.mobile-menu-drawer__backdrop');

  function openMobileMenu() {
    if (mobileDrawer) {
      mobileDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileMenu() {
    if (mobileDrawer) {
      mobileDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (menuToggle) {
    menuToggle.addEventListener('click', openMobileMenu);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeMobileMenu);
  }

  if (backdrop) {
    backdrop.addEventListener('click', closeMobileMenu);
  }

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('is-open')) {
      closeMobileMenu();
    }
  });

  // Submenu toggle for accessibility (desktop)
  document.querySelectorAll('.header--bookshop .menu-list__link[aria-haspopup="true"]').forEach(button => {
    button.addEventListener('click', (e) => {
      const expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', !expanded);
    });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (!button.parentElement.contains(e.target)) {
        button.setAttribute('aria-expanded', 'false');
      }
    });

    // Keyboard navigation
    button.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        button.setAttribute('aria-expanded', 'false');
        button.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
